<style>
#fileElem {
    display: none;
}

.inputs {
    margin-top: 15px;
}

.pell {
    border-radius: 10px;
    border: 1px solid #ccc;
    margin: 0 0 0.5em 0;
    margin-top: 5px;
}

.input-holder {
    margin-bottom: 10px;
}
</style>

<script>
import * as Common from '../Common.js'
import {push} from '../pt-router/Router.svelte'
import pell from 'pell'
import {onMount} from 'svelte'

export let area

let editor
let areaUpdate = {
    information: ''
}
let fileElem


onMount(() => {
    pell.init({
    element: editor,
    onChange: html => {areaUpdate.information = html.replace('https://ik.imagekit.io/plantogether/', 'IMG_URL/')},
    defaultParagraphSeparator: 'div',
    styleWithCSS: false,
    actions: [
        'bold',
        'underline',
        'italic',
        'strikethrough',
        'olist',
        'ulist',
        {
            name: 'link',
            result: () => {
                const url = window.prompt('Enter the link URL')
                if (url) pell.exec('createLink', url)
            }
        },
        {
            name: 'image',
            result: () => {
                addPicture()
            }
        }
    ],
    classes: {
        actionbar: 'pell-actionbar',
        button: 'pell-button',
        content: 'pell-content',
        selected: 'pell-button-selected'
    }
    })

    editor.content.innerHTML = Common.sanitizeContent(area.information)
    areaUpdate.information = area.information
})

function onFileAdd(e) {
    // UploadFile
    if(fileElem.files.length == 0) {
        return;
    }

    let formData = new FormData();

    Common.getData("imageuploadtoken")
    .then(data => {
        console.log(data)

        formData.append("file", fileElem.files[0]);
        formData.append("fileName", fileElem.files[0].name);
        formData.append("publicKey", "public_we5ticUsUXZ7EafhcSIbwfOjDTo=")
        formData.append("token",data.token)
        formData.append("expire",data.expire)
        formData.append("signature",data.signature)

        Common.CreateNotification({body: "Uploading Picture!"}, 500)

        fetch('https://upload.imagekit.io/api/v1/files/upload', {
            method: 'POST',
            body: formData
        })
        .then(r => {
            if(r.status != 200) {
                alert("Error uploading picture.");
                r.text().then(t => console.log(t))
                return
            }

            return r.json()
        })
        .then(data => {
            pell.exec('insertImage', 'https://ik.imagekit.io/plantogether/'+ data.name)
        })
    })
}

function addPicture() {
    editor.content.focus()
    if (fileElem) {
        fileElem.click();
    }
}

function submit() {
    console.log(areaUpdate)
    Common.postData('tools/area/' + area.id + '/update', areaUpdate)
    .then(r => {
        if(!r.ok) {
            alert("Problem updating Area Profile. Please try again.")
            return
        }
        
        Common.CreateNotification({body: "Area Profile Updated!"}, 500)
        push('/area/' + area.id)
    })
}

</script>

<h1>{area.name} Profile</h1>

<div class="input-holder">
    <strong>Profile</strong><br>
    <div class="pell" bind:this={editor}></div>
    <input bind:this={fileElem} multipart type="file" id="fileElem" accept="image/*" style="display:none" on:change={onFileAdd}>
    <button class="submit" on:click={submit}>Update</button>
</div>